
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34.2 34.2","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"17.1","cy":"17.1","fill":"#bdccd4","r":"17.1"}}),_c('g',{attrs:{"fill":"#1d1e35"}},[_c('path',{attrs:{"d":"M11.78 14.05H7.53a.47.47 0 00-.47.47v5.17c0 .26.21.47.47.47h4.25c1.11 0 2.2.23 3.21.68l2.79 1.23c.37.16.79-.11.79-.51v-8.9c0-.41-.42-.68-.79-.51l-2.79 1.23c-1.01.44-2.1.67-3.21.67zM25.88 17.23l3.03-3.03c.1-.1.1-.26 0-.35l-.71-.71c-.1-.1-.26-.1-.35 0l-3.03 3.03-3.03-3.03c-.1-.1-.26-.1-.35 0l-.71.71c-.1.1-.1.26 0 .35l3.03 3.03-3.03 3.03c-.1.1-.1.26 0 .35l.71.71c.1.1.26.1.35 0l3.03-3.03 3.03 3.03c.05.05.11.07.18.07s.13-.02.18-.07l.71-.71c.1-.1.1-.26 0-.35z"}})])])
          )
        }
      }
    